import { Premiere as NationalPremiere } from '@filmweb/sanity-types';
import { format, parse } from 'date-fns';

//#region [Props]
type PremiereProps = {
	nationalPremiere?: NationalPremiere;
	localPremiere?: string;
};
//#endregion

const uncertainFormat = "MMMM yyyy";
const certainFormat = "dd.MM.yyyy";

const stringFormat = "yyyy-MM-dd"

//#region [Component]
export default function Premiere({ nationalPremiere, localPremiere }: PremiereProps) {
	let formattedDate: string | null = null;
	if (!localPremiere) {
		if (!nationalPremiere?.noCinemaRelease) {
			if (nationalPremiere?.expectedPremiereDate) {
				formattedDate = format(parse(nationalPremiere!.expectedPremiereDate, stringFormat, new Date()), uncertainFormat);
			}
			if (nationalPremiere?.premiereDate) {
				formattedDate = format(parse(nationalPremiere!.premiereDate, stringFormat, new Date()), certainFormat);
			}
		}
	} else {
		formattedDate = format(parse(localPremiere, "yyyy-MM-dd", new Date()), certainFormat);
	}
	if (formattedDate) {
		return <div><dd>Premiere:</dd><dt>{formattedDate}</dt></div>
	}

	return null;
}
//#endregion